
const Moralis = require('moralis');

const appId = "vHqAWlRhO29gDrzdYEtywkN3oFxIUn5jmqaolSOj"

const serverUrl = 'https://jhhjnhvuhf6g.moralishost.com:2053/server'

Moralis.start({ serverUrl, appId });
